export default
{
    IR_TL: 'image_right_text_left',
    IL_TR: 'image_left_text_right',
    I_FULL: 'image_full',
    I_FIT: 'image_fitted',
    I_T: 'images_text'
}



// WEBPACK FOOTER //
// ./src/scripts/constants/restaurant-blocks-types.js